"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _connectToWebChat = _interopRequireDefault(require("../connectToWebChat"));

var _TimeAgo = _interopRequireDefault(require("../Utils/TimeAgo"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var _default = (0, _connectToWebChat.default)(function (_ref) {
  var styleSet = _ref.styleSet;
  return {
    styleSet: styleSet
  };
})(function (_ref2) {
  var timestamp = _ref2.activity.timestamp,
      className = _ref2.className,
      styleSet = _ref2.styleSet;
  return _react.default.createElement("span", {
    className: (0, _classnames.default)(styleSet.timestamp + '', (className || '') + '')
  }, _react.default.createElement(_TimeAgo.default, {
    value: timestamp
  }));
});

exports.default = _default;